# frozen_string_literal: true

module Engine
  module Game
    module G1862UsaCanada
    end
  end
end
